import React from 'react';
import useThemeColors from '../../../hooks/useThemeColors';

const HorizontalTabs = ({ tabs, activeTab, onTabChange, className = "" }) => {
  const { colors, isDark } = useThemeColors();

  if (!tabs || tabs.length === 0) {
    return null;
  }

      return (
      <div className={`w-full ${className}`}>
        <div className="flex flex-wrap gap-2 gap-y-3 pb-2">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`
              flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all duration-200 whitespace-nowrap
              ${activeTab === tab.id 
                ? `${isDark ? 'bg-blue-600 !text-white' : 'bg-blue-500 !text-white'} shadow-lg` 
                : `${isDark ? 'bg-gray-700 text-gray-300 hover:bg-gray-600' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'} hover:shadow-md`
              }
            `}
            style={{
              backgroundColor: activeTab === tab.id 
                ? colors.primary || (isDark ? '#2563eb' : '#3b82f6')
                : isDark ? colors.specialBackground || '#374151' : colors.specialBackground || '#f3f4f6',
              color: activeTab === tab.id 
                ? '#ffffff'
                : colors.textColor || (isDark ? '#d1d5db' : '#374151'),
            }}
          >
            {tab.icon && (
              <div className="w-5 h-5 flex items-center justify-center">
                {typeof tab.icon === 'string' ? (
                  <img 
                    src={tab.icon} 
                    alt={tab.label} 
                    className="w-5 h-5 rounded-full"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                ) : (
                  <span className="text-current">{tab.icon}</span>
                )}
              </div>
            )}
            <span className={`text-sm font-medium ${activeTab === tab.id ? '!text-white' : 'text-black'}`}>{tab.label}</span>
            {activeTab === tab.id && (
              <div 
                className="w-2 h-2 rounded-full"
                style={{
                  backgroundColor: isDark ? '#ffffff' : '#ffffff'
                }}
              ></div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default HorizontalTabs; 